import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Callout from 'modules/core/components/Callout'
import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCancelUploadProcess } from 'modules/documents/hooks/useCancelUploadProcess'
import { UploadProcess } from 'modules/documents/hooks/useGetUploadProcess'

interface Props {
  uploadProcess: UploadProcess
  onClose: () => void
  onCancel: () => void
  title?: string
  description?: string
  cancelText?: string
  submitText?: string
  infoText?: string
}

const CancelUploadProcess = ({
  uploadProcess,
  onClose,
  onCancel,
  title,
  description,
  cancelText,
  submitText,
  infoText,
}: Props) => {
  const { cancelUploadProcess, loading } = useCancelUploadProcess()

  const onSubmit = async () => {
    const result = await cancelUploadProcess({ id: uploadProcess.id })

    const handled = handleResult(result, () => null)

    if (handled.success) {
      onCancel()
      onClose()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('split_documents.upload_process.cancel_modal.error_message'),
      })
    }
  }

  const defaultTitle = i18n.t('split_documents.upload_process.cancel_modal.title_v2')
  const defaultDescription = i18n.t('split_documents.upload_process.cancel_modal.description_v2')
  const defaultCancelText = i18n.t('split_documents.upload_process.cancel_modal.close_modal_v2')
  const defaultSubmitText = i18n.t('split_documents.upload_process.cancel_modal.submit_v2')

  return (
    <Modal
      illustration="alert"
      title={title || defaultTitle}
      description={description || defaultDescription}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {cancelText || defaultCancelText}
          </Button>
          <Button submit loading={loading}>
            {submitText || defaultSubmitText}
          </Button>
        </>
      }
    >
      {infoText && <Callout type="info" description={infoText} />}
    </Modal>
  )
}

export default observer(CancelUploadProcess)
